import { Step } from "react-joyride";
import { VisibilityStates } from "../../types/VisibilityStates";

export const tourStepsNameGenerator = (
  visibilityStates: VisibilityStates,
): Step[] => {
  const steps: Step[] = [
    {
      target: ".name-generator",
      content:
        "The name spinner picks a student at random. Click the wheel or the + button to add names, then spin.",
      disableBeacon: true,
    },
    {
      target: "#nameInput",
      content:
        "Type a name here. You can also click an empty slice on the wheel to add a name.",
      ...(visibilityStates.isNameInputVisible ? { isOpen: true } : {}),
    },
    {
      target: ".add-name-button",
      content: "Add puts the name on the wheel and in the list on the right.",
      ...(visibilityStates.isAddNameButtonVisible ? { isOpen: true } : {}),
    },
    {
      target: ".spin-button",
      content:
        "Spin chooses a name. After a short delay that name can leave the wheel if Remove after pick is on.",
      ...(visibilityStates.isSpinButtonVisible ? { isOpen: true } : {}),
    },
    {
      target: ".slice-colors",
      content:
        "Choose a color set for the slices, or Custom to pick a color for each name. Colors are saved for next time.",
    },
    {
      target: "ul.list-none",
      content:
        "Uncheck a name to take it off the wheel without deleting it. Check it to put it back. You can also edit or remove names.",
      ...(visibilityStates.isNamesListVisible ? { isOpen: true } : {}),
    },
  ];

  return steps.filter((step) => {
    if (step.target === "#nameInput")
      return visibilityStates.isNameInputVisible;
    if (step.target === ".add-name-button")
      return visibilityStates.isAddNameButtonVisible;
    if (step.target === ".spin-button")
      return visibilityStates.isSpinButtonVisible;
    if (step.target === "ul.list-none")
      return visibilityStates.isNamesListVisible;
    return true;
  });
};
